import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { cancelIcon, saveIcon, SVGIcon } from '@progress/kendo-svg-icons';
import { HttpClient } from '@angular/common/http';
import { UrlHelperService } from '@core/services/url-helper.service';
import { RedeploymentOrderSearchResult } from '@shared/interfaces/gridrows/redeployment-order-search-result.interface';


@Component({
    selector: 'app-item-split',
    templateUrl: './item-split.component.html',
    styleUrls: ['./item-split.component.css'],
    standalone: false
})

export class ItemSplitComponent implements OnChanges {

  public saveIcon: SVGIcon = saveIcon;
  public cancelIcon: SVGIcon = cancelIcon;

  public active = false;
  public editForm: FormGroup;

  @Input() public IsNew: boolean = false;
  @Input() public model: RedeploymentOrderSearchResult;

  @Output() cancel: EventEmitter<undefined> = new EventEmitter();
  @Output() save: EventEmitter<RedeploymentOrderSearchResult> = new EventEmitter();

  constructor(private http: HttpClient, private urlHelper: UrlHelperService) { }

  ngOnChanges() {
    this.active = this.model != undefined;
    if (this.model != undefined) {
      this.editForm = new FormGroup({
        id: new FormControl(this.model.id),
        projectName: new FormControl(this.model.orderNumber)   
      });
    }
  }

  public onSave(e: PointerEvent): void {
    e.preventDefault();

    this.save.emit(this.editForm.getRawValue());
    this.active = false;
  }

  public onCancel(e: PointerEvent): void {
    e.preventDefault();
    this.closeForm();
  }

  public closeForm(): void {
    this.active = false;
    this.cancel.emit();
  }

}
